import { render, staticRenderFns } from "./FolderMove.vue?vue&type=template&id=e3d1baf8"
import script from "./FolderMove.vue?vue&type=script&lang=js"
export * from "./FolderMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports